import React, { Component, Fragment } from 'react';
import DatePicker from "react-datepicker";

export const formatDate = (date) => {
  if (!date) {
    return '';
  }

  if (typeof date === 'string') {
    date = new Date(date);
  }

  let wd = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat',
  ][date.getDay()];

  let mmm = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ][date.getMonth()];

  let dd = date.getDate();
  if (dd.toString().length === 1) {
    dd = `0${dd}`;
  }

  let yyyy = date.getFullYear();

  let s = `${wd} ${mmm} ${dd} 12:00:00 UTC ${yyyy}`;
  return s;
}

export const formatDateShort = (date) => {
  if (!date) {
    return '';
  }

  if (typeof date === 'string') {
    date = new Date(date);
  }

  let dd = date.getDate();
  if (dd.toString().length === 1) {
    dd = `0${dd}`;
  }

  let mm = date.getMonth() + 1;
  if (mm.toString().length === 1) {
    mm = `0${mm}`;
  }

  let yyyy = date.getFullYear();

  let s = `${mm}/${dd}/${yyyy}`;
  return s;
}

class DateField extends Component {
  state = {
    value: this.props.value,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.value !== this.props.value) {
      this.setState({
        value: this.props.value,
      });
    }

    if (prevProps.clearForm !== this.props.clearForm) {
      this.setState({
        value: this.props.value,
      });
    }
  }

  renderField(field, value) {
    return (
      <DatePicker
        name={''}
        selected={value}
        // minDate={this.state.start_date ? moment(this.state.start_date) : moment().subtract(100, "years")}
        onChange={(date) => {
          this.setState({
            value: formatDate(date),
          }, () => {
            if (this.props.inline) {
              let formField = document.querySelector(`#${this.props.formId} [name="${field.key}"]`);
              formField.value = formatDate(date);
            } else {
              this.props.form.onChange();
            }
          });
        }}
        // popperModifiers={{
        //   flip: {
        //     enabled: true,
        //   }
        // }}
        dateFormat="MM/dd/yyyy"
        readOnly={false}
        dropdownMode="select"
        showMonthDropdown={true}
        showYearDropdown={true}
      />
    )
  }

  render() {
    let { label, field } = this.props;
    
    let value = new Date();
    if (this.props.field.futureTime && this.props.value === '') {
      value = new Date('December 30, 2099 23:00:00');
    }

    if (this.state.value) {
      value = new Date(this.state.value);
    }

    if (this.props.inline) {
      return this.renderField(field, value);
    }

    return (
      <Fragment>
        <div className="text-label-info-left">
          <label>{label}</label>
          <div className="text-input-group">
            <input type="hidden" name={field.key} value={formatDate(value)} />
            {this.renderField(field, value)}
          </div>
        </div>
      </Fragment>
    )
  }
}

export default DateField;